import { DismissingCard } from '../DismissingCard/index.js';
import * as React from 'react';
import { useState, useCallback } from 'react';
import FeedbackCardContext from './context.js';
import StepsWrapper from './steps/index.js';
import { Steps, Feedback } from './types.js';

const FeedbackCard = ({ className , copyConfig , onSubmit , onDismiss =()=>void 0 , reasonRequired =false , hasTimeout =true , hasDismissButton =true , hasUndoButton =true  })=>{
    const [reason, setReason] = useState("");
    const [step, setStep] = useState(Steps.Emoji);
    const [feedback, setFeedback] = useState(Feedback.Horrible);
    const resetState = useCallback(()=>{
        setFeedback(Feedback.Horrible);
        setReason("");
    }, []);
    const handleFeedback = useCallback((newFeedback)=>{
        setFeedback(newFeedback);
        setStep(Steps.Reason);
    }, []);
    const handleSubmit = useCallback(()=>{
        onSubmit({
            feedback,
            reason
        });
        setStep(Steps.Conclusion);
        resetState();
    }, [
        feedback,
        reason,
        onSubmit,
        resetState
    ]);
    const handleDismiss = useCallback(()=>{
        onDismiss();
    }, [
        onDismiss
    ]);
    return /*#__PURE__*/ React.createElement(FeedbackCardContext.Provider, {
        value: {
            feedback,
            reason,
            setReason,
            copyConfig,
            reasonRequired,
            handleFeedback,
            handleDismiss,
            handleSubmit
        }
    }, /*#__PURE__*/ React.createElement(DismissingCard, {
        className: className,
        hasTimeout: hasTimeout,
        hasCircleButton: hasDismissButton,
        hasUndo: hasUndoButton,
        undoButtonText: copyConfig.undoButtonText,
        onDismiss: handleDismiss,
        dismissedText: copyConfig.dismissedText ?? ""
    }, /*#__PURE__*/ React.createElement(StepsWrapper, {
        step: step
    })));
};

export { FeedbackCard };
